import React from 'react';

const DefaultIcon: React.FC<{}> = () => (
	<span className="text-brand">
		<svg 
			xmlns="http://www.w3.org/2000/svg" 
			className="h-4 w-4"
			viewBox="0 0 17 17" 
			fill="currentColor"
		>
			<path fillRule="evenodd" clipRule="evenodd" d="M8.2 0C3.7 0 0 3.7 0 8.2C0 12.8 3.7 16.4 8.2 16.4C12.8 16.4 16.4 12.7 16.4 8.2C16.4 6 15.5 3.9 14 2.4C12.5 0.9 10.4 0 8.2 0ZM7.4 3.3H9.1V5H7.4V3.3ZM5.8 8.2V6.6H7.4H9.1V13.2H7.4V8.2H5.8Z"/>
		</svg>
	</span>
);

export default DefaultIcon;